export default __webpack_public_path__ + "static/media/darkBlueDownload.166263ac.svg";